import React, { useState, useCallback, useEffect } from 'react';
import { TextField, useDataProvider, ReferenceField } from 'react-admin';
import { handleAPIErrors } from '../../../utils';
import { List } from '../../../components/List';
import StyledDatagrid from '../../../components/StyledDatagrid';
import { CustomPagination } from '../../../components/CustomPagination';
import NoItemsPage from '../../../components/NoItemsPage';
import ListHeader from './ListHeader';
import NameField from './NameField';
import ConsentItemsCountField from './ConsentItemsCountField';
import ListItemActions from './ListItemActions';
import MainListWrapper from '../../../components/MainListWrapper';

const CustomMobileSolutionsList = props => {
  const {permissions} = props;
  const [loading, setLoading] = useState(true);
  const dataProvider = useDataProvider();
  const getMobileConsentSolutions = useCallback(() => {
    return dataProvider
      .getList(props.resource, {
        pagination: { page: 1 },
        sort: { field: 'name', order: 'DESC' },
      })
      .then((solutionsResponse) => {
        return solutionsResponse;
      })
      .catch((error) => {
        handleAPIErrors(error, props.history);
        console.error(error);
      });
  }, [dataProvider, props.history]);

  const initializeList = useCallback(() => {
    getMobileConsentSolutions().then((mobileConsentSolutions = {}) => {
      setLoading(false);
    });
  }, [getMobileConsentSolutions]);

  useEffect(() => initializeList(), [initializeList]);

  if (loading === true) {
    return null;
  }

  return (
    <MainListWrapper>
      <List
        {...props}
        actions={null}
        filters={<ListHeader/>}
        filter={{}}
        bulkActionButtons={false}
        sort={{field: 'name', order: 'DESC'}}
        empty={ <NoItemsPage
          buttonText="CREATE MOBILE CONSENT SOLUTION"
          href="#/universal_consent_solutions/create"
          title="No Mobile Consent Solutions yet"
          subtitle="Create a Mobile Consent Solution to get started"
        />}
        pagination={<CustomPagination/>}
      >
        <StyledDatagrid>
          { permissions === 'ROLE_ADMIN' ?
              <ReferenceField
                label="Account"
                source="account"
                reference="accounts"
                sortable={false}
              >
                <TextField source="name" />
              </ReferenceField> : null }
          <NameField label="Name" source="name"/>
          {/*
          this is commented out due to CI-3913 and should be removed in future due to CI-3894
          <ApplicationNameField label="Application Name" source="applicationName"/>
          */}
          <ReferenceField
            label="Operating system"
            source="mobileOperatingSystem"
            reference="mobile_operating_systems"
            sortable={false}
            link={false}
          >
            <TextField source="name" />
          </ReferenceField>
          <ConsentItemsCountField label="Consent items"/>
          <ListItemActions/>
        </StyledDatagrid>
      </List>
    </MainListWrapper>
  );
};

export default CustomMobileSolutionsList;
